import { render, staticRenderFns } from "./prizeDetailsManage.vue?vue&type=template&id=05b87d67&scoped=true&"
import script from "./prizeDetailsManage.vue?vue&type=script&lang=ts&"
export * from "./prizeDetailsManage.vue?vue&type=script&lang=ts&"
import style0 from "./prizeDetailsManage.vue?vue&type=style&index=0&id=05b87d67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b87d67",
  null
  
)

export default component.exports